import styled from 'styled-components';

import ModalConfirm from '../modal-confirm';

const Container = styled.div`
  display: flex;
  justify-content: center;
  ${({ center }) => (center && `
    align-items: center;
    margin-top: 80px;
  `)}
`;

const ModalCancel = styled(ModalConfirm)``;

const ModalSave = styled(ModalConfirm)``;

export {
  Container,
  ModalSave,
  ModalCancel,
};
